import { Colors, Services, joinURLPath } from '@sigma-frontend-libs/commons'
import { MODERATION_VALUES } from '@sigma-legacy-libs/essentials/lib/constants'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

export default {
  name: 'Buttons',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      showRejectMenu: false,
      approveLoading: false,
      rejectLoading: false
    }
  },

  computed: {
    canUpdateSendernamesAsAdmin() {
      return this.checkPermissions(`advanced.${Services.sendernames}.update`)
    },

    // INFO: https://sigmasms.slack.com/archives/D01SHR01X1R/p1656321489405479
    rejectVariants() {
      return {
        contact: 'По регистрации имени свяжитесь с нами по телефону 8 800 333 16 50',
        comment: 'В поле "Комментарий" добавьте полное наименование юридического лица и ИНН',
        length: 'Имя отправителя должно содержать от 4 до 11 латинских букв',
        common: 'Общее имя отправителя',
        international: 'Международное имя отправителя'
      }
    }
  },

  methods: {
    showSnackbar() {
      this.addSnackbar({
        text: this.getTranslate(`${Services.sendernames}.snackbars.updated`),
        type: Colors.success
      })
    },

    async approve() {
      try {
        this.approveLoading = true
        // INFO: https://sigmasms.slack.com/archives/D01SHR01X1R/p1656321489405479
        // INFO: https://sigmasms.slack.com/archives/C03RRLZB8MP/p1779950798647669
        const adminComment = 'Активно по Теле2, по работе имени на МТС, Мегафон и Билайн - обратитесь к своему менеджеру'
        const response = await request.update(joinURLPath(Services.sendernames, this.value.id), {
          body: {
            ...this.value,
            moderation: MODERATION_VALUES.approved,
            meta: { adminComment }
          }
        })
        if (response) {
          this.showSnackbar()
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.approveLoading = false
      }
    },

    async reject(variant) {
      try {
        this.rejectLoading = true
        const replacement = {
          moderation: MODERATION_VALUES.rejected,
          meta: { adminComment: 'Причина не указана' }
        }
        if (variant) {
          replacement.meta.adminComment = this.rejectVariants[variant]
        }
        const response = await request.update(joinURLPath(Services.sendernames, this.value.id), {
          body: {
            ...this.value,
            ...replacement
          }
        })
        if (response) {
          this.showSnackbar()
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.rejectLoading = false
      }
    }
  },

  render
}
